// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__FkCVt","title":"Info_title__3cJaS","selects":"Info_selects__3-Ava","requiredAsterisk":"Info_requiredAsterisk__2uiJy"};